<template>
    <div>
        <h3 class="text-center">Detect trackers with BLE..</h3>
        <div class="m-2">
            <div v-if="device">Device: {{device.name}}</div>
            <pre v-if="msg">{{msg}}</pre>
        </div>
        <br>
        <button class="btn btn-block btn-primary" @click="ble_service">connect tracker</button>
        <div v-if="server&&!secure">
            <button class='btn btn-block btn-secondary' @click="read_auth(0x2)">Process auth with reset</button>
            <button class='btn btn-block btn-secondary' @click="read_auth(0x0)">Process auth </button>
        </div>
        <div v-if="secure">
            <button class='btn btn-block btn-secondary' @click="read_mode">Read mode</button>
            <button class='btn btn-block btn-secondary' @click="write_mode(235)">Write mode 235</button>
            <button class='btn btn-block btn-secondary' @click="write_mode(1)">Write mode 1</button>
        </div>
    </div>
</template>

<script>
    function padHex(value) {
        return ('00' + value.toString(16).toLowerCase()).slice(-2);
    }

    function buf2hex(buffer) {
            return Array.from(new Uint8Array(buffer))
            .map(b => b.toString(16).padStart(2, "0"))
            .join("");
    }

    let serviceUuid = 'f27a4900-92d6-49bf-8ac0-a661ccfbcb37';
    let newDataServiceUuid = 'f27a4900-92d6-49bf-8ac0-a661ccfbcb38';
    const trackerServiceConfigUuid = '011b1500-2212-4dbf-9e2b-6722a4552380';
    const trackerConfigAuthCharUuid = '011b1501-2212-4dbf-9e2b-6722a4552380';
    const trackerConfigModeCharUuid = '011b1503-2212-4dbf-9e2b-6722a4552380';

    import {HTTP} from '../http-constants'

    export default {
        name: "WebBLE",
        data() {
            return {
                device: null,
                server: null,
                characteristic: null,
                board_name: null,
                serial: null,
                msg: null,
                char_value: null,
                secure: false
            }
        },
        methods: {
            'write_auth': function (signature, flag) {
                var self = this;
                const binary = Uint8Array.from(atob(signature), c => c.charCodeAt(0))
                const data = Uint8Array.of(flag, ...binary);
                self.characteristic.writeValue(data).then(blah => {
                    self.secure = true
                    self.msg += "Secure connection\n";
                }).catch(error => {
                    self.msg += 'Error writing auth: ' + error + '\n'
                })
            },
            'read_mode': function () {
                var self = this;
                self.server.getPrimaryService(trackerServiceConfigUuid)
                    .then(service => {
                        return service.getCharacteristic(trackerConfigModeCharUuid)
                    })
                    .then(characteristic => {
                        return characteristic.readValue()
                    })
                    .then(value => {
                        self.msg += "Mode value " + buf2hex(value.buffer) + '\n';
                    })
                    .catch(error => {
                        self.msg += 'Error writing mode: ' + error + '\n'
                    })
            },
            'write_mode': function(mode) {
                var self = this;
                self.server.getPrimaryService(trackerServiceConfigUuid)
                    .then(service => {
                        return service.getCharacteristic(trackerConfigModeCharUuid)
                    })
                    .then(characteristic => {
                        const buffer = Uint8Array.of(mode)
                        return characteristic.writeValue(buffer)
                    })
                    .then(value => {
                        console.log("mode written")
                    })
                    .catch(error => {
                        self.msg += 'Error written mode: ' + error + '\n'
                    })
            },
            'sign_request': function(data, flag) {
                var self = this;
                var payload = {'data': data};
                if (this.board_name) {
                    payload.board_name = this.board_name;
                }
                HTTP.post('/devices/trackers/sign_request/', payload)
                    .then(function (re) {
                        const sig = re.data.signature;
                        console.log(sig)
                        self.write_auth(sig, flag);
                    })
                    .catch(function (error) {
                        console.log(error);
                        self. msg += "sign request" + error.response + '\n';
                    })
            },
            'handleHardwareCharacteristic': function (characteristic) {
                var self = this
                let decoder = new TextDecoder('utf-8');

                this.queue = this.queue.then(_ => characteristic.readValue()).then(value => {
                    self.msg += 'Board name: ' + decoder.decode(value) + '\n'
                    self.board_name = decoder.decode(value)
                });
            },
            'handleSystemID': function (characteristic) {
                var self = this
                let decoder = new TextDecoder('utf-8');
                this.queue = this.queue.then(_ => characteristic.readValue()).then(value => {
                    self.serial = padHex(value.getUint8(7)) + padHex(value.getUint8(6)) +
                        padHex(value.getUint8(5)) + padHex(value.getUint8(4)) +
                        padHex(value.getUint8(3)) + padHex(value.getUint8(2)) +
                        padHex(value.getUint8(1)) + padHex(value.getUint8(0))
                    self.msg += 'Identifier: ' + self.serial + '\n'
                });
            },
            'ble_service': function () {
                var self = this;
                self.msg = "Requesting Bluetooth Device...\n";
                self.device = null;
                self.server = null;
                self.secure = false;
                navigator.bluetooth.requestDevice({
                    filters: [
                        {services: [serviceUuid]},
                        {services: [newDataServiceUuid]}
                    ],
                    optionalServices: ['device_information', trackerServiceConfigUuid]
                })
                    .then(device => {
                        self.msg = `Connecting to device...\n`
                        self.device = device
                        return device.gatt.connect();
                    })
                    .then(server => {
                        //self.msg += `Getting Device Information Service...\n`
                        self.server = server
                        return server.getPrimaryService('device_information');
                    })
                    .then(service => {
                        this.queue = Promise.resolve();
                        service.getCharacteristic('hardware_revision_string').then(self.handleHardwareCharacteristic)
                        service.getCharacteristic('system_id').then(self.handleSystemID)
                    })
                    .catch(error => {
                        self.msg += 'Error: ' + error + '\n'
                    });
            },
            'read_auth': function (flag) {
                var self = this;
                self.server.getPrimaryService(trackerServiceConfigUuid)
                    .then(service => {
                        service.getCharacteristic(trackerConfigAuthCharUuid)
                            .then(characteristic => {
                                self.characteristic = characteristic;
                                this.queue = this.queue.then(_ => characteristic.readValue()).then(value => {
                                    const str_value = buf2hex(value.buffer);
                                    self.char_value = str_value;
                                    const _buffer = new Uint8Array(value.buffer);
                                    let base64String = btoa(String.fromCharCode(..._buffer, flag));
                                    self.sign_request(base64String, flag)
                                })
                            })
                    })
                    .catch(error => {
                        self.msg += 'Error reading ble: ' + error + '\n'
                    });
            },
        },
        mounted: function () {
        }
    }
</script>